import React, { useEffect, useState } from "react";
import "./login.css"

import FormLogin from "./FormLogin";
import { Row, Col } from "reactstrap";
import { useResponsive } from "../../../hooks/useResponsive";

const Login: React.FC = () => {
  const [ screen, setScreen ] = useState("100%");
  const { isMobile, isTablet, isDesktop, isScreenBig } = useResponsive();

  useEffect(() => {
    if(isMobile) setScreen("525px");
    else if(isTablet) setScreen("590px");
    else if(isDesktop) setScreen("600px");
    else if(isScreenBig) setScreen("auto");
    else setScreen("auto");
  },[isMobile, isTablet, isDesktop, isScreenBig]);

  return (
    <div className="page-main p-0">
      <div className="container-fluid m-0 p-0">
        <Row className="d-lg-flex d-none vh-100 p-0">
          <Col lg={6}>
            <FormLogin responsive={false}/>          
          </Col>
          <Col lg={6} className="p-0">
            <div className="img-background-login"/>
          </Col>
        </Row>
        <Row className="d-lg-none d-block vh-100">
          <Col>
            <FormLogin  responsive={true}/>
          </Col>
        </Row>

        <div className="footer m-0 p-0">
          <div className="container">
            <div className="row text-center mt-2">
              <p>Ao entrar, concordo com os Termos e Políticas da Alumisoft Sistemas.</p> 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
